import React, { useState, useEffect } from 'react';
import { ReactSelect } from 'components/FormHelpers/FormInputs';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TE } from 'appconstants';

const SitePicker = ({
  allSites,
  onChanged,
  orgTypeExp,
  selSite,
  name,
  validators,
  errorMessages,
  isDisabled,
  hideCtepIdInDropdown
}) => {
  const [sites, setSites] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const filteredSites = _.filter(allSites, (o) => (orgTypeExp ? o.ognType.match(`${orgTypeExp}`) : o));
    const allSiteSuggestions = _.sortBy(filteredSites.map(el => ({
      value: el.ctepId,
      label: `${hideCtepIdInDropdown ? '': `${el.ctepId}-`}${el.name}`
    })), [ o => o.value ]);
    setSites(allSiteSuggestions);
    setSuggestions(allSiteSuggestions);
  }, [allSites, orgTypeExp, setSites, setSuggestions, hideCtepIdInDropdown]);


  useEffect(() => {
    const initValue = sites && _.find(sites, (item) => selSite === item.value);
    setSelected(initValue);
  }, [setSelected, selSite, sites]);

  const handleInputChange = val => {
    const lcVal = val && val.toLowerCase();
    setSuggestions(_.filter(sites, (item) => item.label.toLowerCase().includes(lcVal)));
  };
  return (
    <ReactSelect
      title="Site Selector"
      name={name}
      data-id={`${TE.ID}${name}${TE.SELECT}`}
      isClearable
      validators={isDisabled ? [] : (validators || [])}
      errorMessages={isDisabled ? [] : (errorMessages || [])}
      options={suggestions && suggestions.slice(0, 20)}
      value={selected || ''}
      onInputChange={handleInputChange}
      onChange={event => {
        setSelected(event);
        onChanged(name, event);
      }}
      disabled={isDisabled}
    />
  );
};


const withConnectState = connect(
  (state, ownProps) => ({
    allSites: state.common.allSites.data
  }),
  dispatch => bindActionCreators({}, dispatch)
);


const OrgSelector = ({
  allSites,
  ...rest
}) => {
  if (_.isUndefined(allSites)) return (<>Loading Sites</>);
  return (
    <SitePicker {...rest} allSites={allSites} />
  );
};


const SiteSelector = compose(
  withConnectState
)(OrgSelector);

SiteSelector.propTypes = {
  onChanged: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

SiteSelector.defaultProps = {
  onChanged: null,
  name: null
};


export default SiteSelector;
